import { createContext, useContext } from "react";

export const CentroContext = createContext({ centro: "", setCentro: () => {} });
export const useCentro = () => useContext(CentroContext);
